import React from 'react';
import styles from './index.less';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface Props {
  title: React.ReactNode;
  style?: React.CSSProperties;
}

const HeadTitle = ({
  title,
  style
}: Props) => {
  return (
    <div className={cx(`header-title__container`)} style={style}>
      <div className={cx(`header-title__container-icon`)}></div>
      <div className={cx(`header-title__container-title`)}>{title}</div>
    </div>
  )
}

export default HeadTitle;